export { default as EditControl } from './EditControl.js';